import React from 'react';

function SkeletonOriginAndDestination() {
  return (
    <div data-testid="skeleton-origin-and-destination">
      <svg
        width="7"
        height="50"
        viewBox="0 0 7 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="3.5" cy="9.5" r="3" stroke="#BABEC9" />
        <rect x="3" y="17" width="1" height="16" fill="#BABEC9" />
        <rect x="0.5" y="37.5" width="6" height="6" stroke="#BABEC9" />
      </svg>
    </div>
  );
}

export default SkeletonOriginAndDestination;
